import { useState } from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/lib/settings";

const COOLDOWN_MS = 30000;

// Posts to the admin-set Google Apps Script link; nothing is stored on our server.
export const useFormSubmit = (type) => {
  const link = useSettings().settings.site.form_submission_link;
  const [status, setStatus] = useState("idle");
  const send = async (fields, honeypot) => {
    if (honeypot) { setStatus("success"); return; }
    const last = Number(localStorage.getItem("os_form_last") || 0);
    if (Date.now() - last < COOLDOWN_MS) { setStatus("error"); return; }
    setStatus("sending");
    try {
      await fetch(link, { method: "POST", mode: "no-cors", body: new URLSearchParams({ type, ...fields, website: "" }) });
      localStorage.setItem("os_form_last", String(Date.now()));
      setStatus("success");
    } catch {
      setStatus("error");
    }
  };
  return { ready: !!link, status, send, reset: () => setStatus("idle") };
};

export const Honeypot = ({ value, onChange }) => (
  <div className="hp-field" aria-hidden="true">
    <input type="text" name="website" tabIndex={-1} autoComplete="off" value={value} onChange={(e) => onChange(e.target.value)} />
  </div>
);

export const FormPage = ({ t, testId, children }) => (
  <main className="page form-page" data-testid={testId}>
    <header className="journey-head">
      <span className="pill">{t.label}</span>
      <h1 className="form-title">{t.title}</h1>
      <p className="heart-lead">{t.supporting}</p>
    </header>
    {children}
  </main>
);

export const Counter = ({ value, max = 1500 }) => <span className="char-counter">{value.length} / {max}</span>;

export const SuccessState = ({ heading, message, again, library, onAgain }) => (
  <div className="form-success" data-testid="form-success">
    <div className="ty-head">
      <span className="ty-ripple" aria-hidden="true"><span /><span /><span /></span>
      <h2 className="modal-title" data-testid="form-success-heading">{heading}</h2>
    </div>
    <p className="modal-text" data-testid="form-success-message">{message}</p>
    <div className="row-actions">
      <button type="button" className="nb-btn" onClick={onAgain} data-testid="form-success-again">{again}</button>
      <Link to="/library" className="nb-btn ghost" data-testid="form-success-library">{library}</Link>
    </div>
  </div>
);
